module.exports = __webpack_public_path__ + "img/dante-layer.b3cd7596.jpg";